<template>
  <div class="modal fade activity-modal" id="logViewModal" ref="logViewModal" data-backdrop="static" data-keyboard="false" aria-labelledby="logModal">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-bold">{{popUpTitle}}</h5>
        </div>
        <div class="modal-body table-responsive-sm">
          <div v-if="logs.length > 0 && logs[0] && logs[0].new_values !== undefined">
            <table aria-describedby="table" class="table table-sm table-bordered font-1">
              <thead>
              <tr class="table-primary">
                <th style="width: 10%;">Event</th>
                <th style="width: 15%;">Label</th>
                <th style="width: 27%;">Old Value</th>
                <th style="width: 27%;">Current Value</th>
                <th style="width: 10%;">Created Or Updated By</th>
                <th style="width: 10%;">Created Or Updated At</th>
              </tr>
              </thead>
              <tbody>
              <template v-for="(log) in logs">
                <template v-if="log.new_values != undefined">
                  <template v-for="(additionalRow, additionalRowIndex) in Object.entries(log.new_values)">
                    <tr>
                      <td v-if="additionalRowIndex == 0" :rowspan="calculateLogRowspan(log)" class="vertical-center font-bold">
                        {{ capitalizeFirstLetterEveryWords(log.event) }}
                      </td>
                      <td class="vertical-center">{{ formatColumnName(additionalRow[0]) }}</td>
                      <td>
                        <template v-if="additionalRow[0] === 'documents'">
                          <div v-if="log.old_values && log.old_values['documents'] !== undefined">
                            <ul class="m-0 custom-list">
                              <li class="mt-1" v-for="(doc, indexA) in log.old_values['documents']" :key="indexA">
                                <a title="View Document" @click="goTogetDocumentPath($event, doc)" class="custom-anchor-class" href="">{{ extractFilename(doc) }}</a>
                              </li>
                            </ul>
                          </div>
                          <div v-else>
                            -
                          </div>
                        </template>
                        <template v-else-if="additionalRow[0] === 'status'">
                          <span>{{ capitalizeFirstLetterEveryWords(getLogOldValueFromObj(log, additionalRow[0])) }}</span>
                        </template>
                        <template v-else-if="additionalRow[0] === 'travel_rate' || additionalRow[0] === 'labor_rate' || additionalRow[0] === 'sub_total' || additionalRow[0] === 'total'">
                          <span>{{ formatCurrency(getLogOldValueFromObj(log, additionalRow[0])) }}</span>
                        </template>
                        <template v-else>
                          <div v-if="isObject(getLogOldValueFromObj(log, additionalRow[0]))">
                            <div v-for="(value, key) in getLogOldValueFromObj(log, additionalRow[0])">
                              <div class="d-flex mb-1" :key="key">
                                <span class="mr-1">
                                    <strong>
                                    {{ capitalizeFirstLetterEveryWords(key) }}:
                                  </strong>
                                </span>
                                <span v-if="key == 'documents'">
                                  <a title="View Document" @click="goTogetDocumentPath($event, value)" class="custom-anchor-class" href="">{{ extractFilename(value) }}</a>
                                </span>
                                <span v-else-if="key == 'sub_total' || key == 'total'">
                                  {{ formatCurrency(value) }}
                                </span>
                                <span v-else>
                                  {{ value }}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div v-else>
                            <span>
                              {{ getLogOldValueFromObj(log, additionalRow[0]) }}
                            </span>
                          </div>
                        </template>
                      </td>
                      <td>
                        <template v-if="additionalRow[0] === 'documents'">
                          <div v-if="log.new_values && log.new_values['documents'] !== undefined">
                            <ul class="m-0 custom-list">
                              <li class="mt-1" v-for="(doc, indexB) in log.new_values['documents']" :key="indexB">
                                <a title="View Document" @click="goTogetDocumentPath($event, doc)" class="custom-anchor-class" href="">{{ extractFilename(doc) }}</a>
                              </li>
                            </ul>
                          </div>
                          <div v-else>
                            -
                          </div>
                        </template>
                        <template v-else-if="additionalRow[0] === 'status'">
                          <span>{{ capitalizeFirstLetterEveryWords(additionalRow[1]) }}</span>
                        </template>
                        <template v-else-if="additionalRow[0] === 'travel_rate' || additionalRow[0] === 'labor_rate' || additionalRow[0] === 'sub_total' || additionalRow[0] === 'total'">
                          <span class="text-right">{{ formatCurrency(additionalRow[1]) }}</span>
                        </template>
                        <template v-else>
                          <div v-if="isObject(additionalRow[1])">
                            <div v-for="(value, key) in additionalRow[1]">
                              <div class="mb-1" :key="key">
                                <span class="mr-1">
                                    <strong>
                                    {{ capitalizeFirstLetterEveryWords(key) }}:
                                  </strong>
                                </span>
                                <span v-if="key == 'documents'">
                                  <a title="View Document" @click="goTogetDocumentPath($event, value)" class="custom-anchor-class" href="">{{ extractFilename(value) }}</a>
                                </span>
                                <span v-else-if="key == 'sub_total' || key == 'total'">
                                  {{ formatCurrency(value) }}
                                </span>
                                <span v-else>
                                  {{ value }}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div v-else>
                            <span v-if="Array.isArray(additionalRow[1]) && additionalRow[1].length === 0">
                              -
                            </span>
                            <span v-else>
                              {{ additionalRow[1] }}
                            </span>
                          </div>
                        </template>
                      </td>
                      <td v-if="additionalRowIndex == 0" :rowspan="calculateLogRowspan(log)" class="vertical-center">
                        {{ getCreatedOrUpdatedUser(log) }}
                      </td>
                      <td v-if="additionalRowIndex == 0" :rowspan="calculateLogRowspan(log)" class="vertical-center">
                        {{ log.created_updated_at }}
                      </td>
                    </tr>
                  </template>
                </template>
              </template>
              </tbody>
            </table>
          </div>
          <div v-else>
            <p class="text-center">No Logs Found</p>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-dismiss="modal" > <i class="fp-close"> </i> Close</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import {contractMixins} from "../mixins/contractMixins";
import {commonMixins} from "../mixins/commonMixins";
export default {
  name: "AuditLogPopUp",
  mixins: [commonMixins, contractMixins],
  props: {
    logs:{
      type: Array,
      required: true,
      default: []
    },
    popUpTitle: {
      type: String,
      required: true,
      default: "Audit Trail Log"
    },
    fileFlag: {
      type: String,
      required: false,
      default: ""
    }
  },
  methods: {
    calculateLogRowspan: function (log) {
      return Object.keys(log.new_values).length > 0 ? Object.keys(log.new_values).length : 1;
    },

    capitalizeFirstLetter(str) {
      if (!str) return '';
      return str.charAt(0).toUpperCase() + str.slice(1);
    },

    capitalizeFirstLetterEveryWords(str) {
    if (!str) return '';
    // Remove underscores and replace with spaces
    const cleanedStr = str.replace(/_/g, ' ');
    // Capitalize the first letter of every word
    return cleanedStr.replace(/\b\w/g, char => char.toUpperCase());
  },
    getLogOldValueFromObj: function(log, additionalRowIndex) {
      return log.old_values
      && log.old_values[additionalRowIndex] !== undefined
      && log.old_values[additionalRowIndex] != ""
      && log.old_values[additionalRowIndex] != null ? log.old_values[additionalRowIndex] : '-';
    },

    formatColumnName: function(columnName) {
      return columnName
        .replace(/[0-9]/g, '')  // Remove numeric characters
        .replace(/_/g, ' ')     // Replace underscores with spaces
        .replace(/\b\w/g, firstLetter => firstLetter.toUpperCase());  // Capitalize the first letter of every word
    },

    getCreatedOrUpdatedUser: function(log) {
      return log.created_by_user || log.updated_by_user;
    },
    extractFilename(url) {
      const urlParts = url.split('/');
      return urlParts[urlParts.length - 1];
    },
    goTogetDocumentPath(event, row){
      event.preventDefault();
      var self = this;
      let path = "";
      if(row.hasOwnProperty('link')){
        path = row.link;
      }else{
        path = row;
      }
      var flag = self.fileFlag;
      var id = 0;
      if(row.id > 0){
        id = row.id;
      }
      self.getDocumentPath(id, path, flag);
    },
    isObject(value) {
      return value && typeof value === 'object' && !Array.isArray(value);
    },
  }
}
</script>
<style scoped>

.vertical-center {
  vertical-align: middle;
}
.font-bold {
  font-family: 'SanFranciscoDisplayBold' !important;
}
.custom-anchor-class{
  color: blue !important;
  text-decoration: underline;
}
.custom-list{
  list-style: none;
}
.modal-body{
  max-height: 700px;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/AuditLogPopUp.vue